__turbopack_context__.v({
  "className": "VOuadq_className",
  "variable": "VOuadq_variable",
});
